import { useEffect } from "react";
import { useFeedback, visibleToasts } from "@/stores/feedback";
import { registerLayer } from "@/ui/layers";
import "@/components/ui/infrastructure.css";

export function FeedbackHost() {
  const { toasts, dismiss, expire } = useFeedback();
  useEffect(() => {
    if (!toasts.length) return;
    const next = Math.min(...toasts.map((toast) => toast.expiresAt));
    const timer = setTimeout(expire, Math.max(0, next - Date.now()));
    return () => clearTimeout(timer);
  }, [toasts, expire]);
  useEffect(() => {
    const first = visibleToasts(toasts)[0];
    if (first) return registerLayer("toast", () => dismiss(first.id));
  }, [toasts, dismiss]);
  return (
    <div className="feedback-host" aria-live="polite" aria-relevant="additions text">
      {visibleToasts(toasts).map((toast) => (
        <div className={`feedback-toast feedback-${toast.kind}`} key={toast.id}>
          <span>
            {toast.kind === "error" ? "! " : toast.kind === "undo" ? "✓ " : "ℹ "}
            {toast.message}
          </span>
          {toast.href && <a href={toast.href}>Upgrade</a>}
          {toast.action && (
            <button
              onClick={() => {
                if (toast.expiresAt <= Date.now()) {
                  dismiss(toast.id);
                  return;
                }
                void Promise.resolve(toast.action?.())
                  .then(() => dismiss(toast.id))
                  .catch(() => {});
              }}
            >
              {toast.actionLabel ?? "Undo"}
            </button>
          )}
          <button aria-label="Dismiss notification" onClick={() => dismiss(toast.id)}>
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
